/**
 * Container component for displaying patient-related statistics.
 * Uses StatsCard components internally to show total, active, and inactive patients.
 * Supports loading states and responsive grid layout.
 * Used in PatientsPage for dashboard-style statistics display.
 */


import React from 'react';
import StatsCard from './StatsCard';

const PatientStatCards = ({ 
  stats = {}, 
  loading = false,
  className = '' 
}) => {
  const {
    totalPatients = 0,
    activePatients = 0,
    inactivePatients = 0,
    callSessions = 0,
    successRate = 0
  } = stats;

  return (
    <div className={`grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 ${className}`}>
      <StatsCard
        title="Total Patients"
        value={totalPatients}
        subtitle="All registered patients"
        color="blue"
        loading={loading}
      />
      
      <StatsCard
        title="Active Patients"
        value={activePatients}
        subtitle="Currently enrolled"
        color="green"
        loading={loading}
      />
      
      <StatsCard
        title="Inactive Patients"
        value={inactivePatients}
        subtitle="Not currently enrolled"
        color="purple"
        loading={loading}
      />
      
      <StatsCard
        title="Success Rate"
        value={`${successRate}%`}
        subtitle="Completion rate"
        color="orange"
        loading={loading}
      />
    </div>
  );
};

export default PatientStatCards;